import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll the window to the top whenever the pathname changes.
 * Mount once inside <BrowserRouter> (above <Routes>) to apply globally.
 *
 * Browsers default to `history.scrollRestoration = 'auto'`, which restores the
 * previous scroll position on back/forward navigation. We switch it to
 * 'manual' so this component is the single source of truth.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // Use rAF so the new route has had a chance to mount before we scroll.
    const id = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
